import {
  ContaRecorrenteLancamentoQuery,
  ContaRecorrenteLancamentoItemResponse
} from "../typings";
import  http  from 'infra/http';

import { useInfiniteQuery } from "react-query";

function useContaRecorrenteLancamentos(id: string, params: ContaRecorrenteLancamentoQuery) {
  const parseValuesParams = Object.values(params)
    .map((value) => `${value}`)
    .join("-");

  return useInfiniteQuery(
    `/v1/conta-recorrente/${id}/lancamentos-${parseValuesParams}`,
    async ({ pageParam }) => {
      const { data } = await http.get<{items: ContaRecorrenteLancamentoItemResponse[]}>(
        `/v1/conta-recorrente/${id}/lancamentos`,
        {
          params: {
            ...params,
            limit: 10,
            page: pageParam,
          },
        }
      );

      return data;
    },
    {
      getNextPageParam: (lastPage, allPages) =>
        lastPage.items.length <  0
          ? undefined
          : allPages.length + 1
    }
  );
}

export default useContaRecorrenteLancamentos;
